import * as Contentful from 'contentful'

import { TypeSectionFields } from './section'
import { TypeItemFeatureHighlight } from './item-feature-highlight'

export enum SectionDynamicKey {
  AIDetector = 'AIDetector',
  BTS2025scrollingBanner = 'BTS2025scrollingBanner',
}

export interface TypeSectionDynamicFields extends TypeSectionFields {
  key: SectionDynamicKey
  heading?: TypeItemFeatureHighlight
}

export type TypeSectionDynamic = Contentful.Entry<TypeSectionDynamicFields>
